












import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
    name: 'c-number-input'
})
export default class CNumberInput extends Vue {
    @Prop({ default: 0 }) readonly value!: number;

    @Prop({ default: false }) readonly disabled!: boolean;

    private get formattedValue(): string {
        return new Intl.NumberFormat('ru-RU').format(this.value);
    }

    @Emit('input')
        private updateValue(newValue: string): number | void {
        const parsedValue = parseFloat(newValue.replace(/[^\d.,-]/g, '').replace(/,/g, '.'));
        if (!isNaN(parsedValue)) {
            return parsedValue;
        } else {
            return 0;
        }
    }

    private onFocus(event: any) {
        event.target.select();
    }

    private noAbc(event: any) {
        // eslint-disable-next-line require-unicode-regexp
       const regex = new RegExp('^-?\\d*[.,]?\\d{0,9}$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    }
}
